import React from 'react';

// MESSAGES
import WebsmsFormattedMessages from '../messages/websms/WebsmsFormattedMessages';

// ICONS
import ComposeIcon from '../components/icons/ComposeIcon';
import BulkSendIcon from '../components/icons/BulkSendIcon';
import InboxIcon from '../components/icons/InboxIcon';
import SentIcon from '../components/icons/SentIcon';
import ScheduledTabIcon from '../components/icons/ScheduleTabIcon';
import ErrorsIcon from '../components/icons/ErrorsIcon';
import TemplatesIcon from '../components/icons/TemplatesIcon';
import AddressBookIcon from '../components/icons/AddressBookIcon';
import SettingsIcon from '../components/icons/SettingsIcon';

export const WebsmsRoutes = [
  {
    path: '/websms/compose',
    label: WebsmsFormattedMessages.composeTitle,
    icon: <ComposeIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/bulk-send',
    label: WebsmsFormattedMessages.bulkSendTitle,
    icon: <BulkSendIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/inbox',
    label: WebsmsFormattedMessages.inboxTitle,
    icon: <InboxIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/sent',
    label: WebsmsFormattedMessages.sentTitle,
    icon: <SentIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/scheduled',
    label: WebsmsFormattedMessages.scheduledTitle,
    icon: <ScheduledTabIcon sx={{ height: '100%', width: '130%' }} />,
  },
  {
    path: '/websms/errors',
    label: WebsmsFormattedMessages.errorsTitle,
    icon: <ErrorsIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/templates',
    label: WebsmsFormattedMessages.templateTitle,
    icon: <TemplatesIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/address_book',
    label: WebsmsFormattedMessages.addressBookTitle,
    icon: <AddressBookIcon sx={{ height: '100%', width: '100%' }} />,
  },
  {
    path: '/websms/settings',
    label: WebsmsFormattedMessages.settingsTitle,
    icon: <SettingsIcon sx={{ height: '100%', width: '100%' }} />,
  },
];
